const ErrorText = (props: { error?: string | false }) => {
  if (!props.error) {
    return null;
  }
  return <p className="mt-2 text-sm text-red-600">{props.error}</p>;
};

export default ErrorText;
